import { Looop } from "../shared/games/Looop";

export const apiLoopsIndex = `/api/looops/`;
export type ApiLoopsIndex = Looop[];

export const apiLoopsShow = (slug: string) => `/api/looops/${slug}`;
export type ApiLoopsShow = Looop;
